import React from "react";
import { NavLink } from "react-router-dom";

const ShotsList = ({ shots, filmId, sceneId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Shots</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/scenes/${sceneId}/shots/overview`}
            activeClassName="is-active">
            Overview
          </NavLink>
        </li>
        <li>
          <NavLink
            to={`/films/${filmId}/scenes/${sceneId}/shots/upload`}
            activeClassName="is-active">
            Upload
          </NavLink>
        </li>
        <hr />
        {(shots || []).map((shot, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/scenes/${sceneId}/shots/${shot.id}/edit`}
                activeClassName="is-active"
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/scenes/${sceneId}/shots/${shot.id}`
                  );
                }}>
                {shot.number}. {shot.shotSizeDescription}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default ShotsList;
